import { styled } from '@mui/material/styles';

export const StyledAnchor = styled('a')({
  textDecoration: 'none',
  '&:focus, &:active': {
    outline: 'none',
  },
});
